module.exports = __webpack_public_path__ + "static/media/background_logo.e9d279cb.png";